import React from 'react';

import { useTranslate } from 'hooks/useTranslations';
import {
  AnalyticsEvents,
  event,
  footerNavigationClickEvent,
} from 'utils/analytics';
import { useCookieSettings } from 'hooks/useCookieSettings';
import { FooterLink } from 'ui/components/FooterLink';

import { CookieSettingsProps } from '../types';

export const CookieSettings = ({ linkStyle }: CookieSettingsProps) => {
  const t = useTranslate();
  const { setShowCookieSettings } = useCookieSettings();

  return (
    <>
      <li role="none" className="flex">
        <FooterLink
          data-test-id="cookie-settings-link"
          role="menuitem"
          href="#"
          linkStyle={linkStyle}
          onClick={clickEvent => {
            clickEvent.preventDefault();
            setShowCookieSettings(true);
            footerNavigationClickEvent('Support:Cookie settings');
            event(AnalyticsEvents.FOOTER_LINK_CLICKED, {
              domevent: t('cookieSettings').toLowerCase(),
            });
          }}
        >
          {t('cookieSettings')}
        </FooterLink>
      </li>
    </>
  );
};

export default CookieSettings;
